var events;
(function (events) {
    events["IMAGE_EDITOR_OPEN"] = "image_editor--editor--open";
    events["IMAGE_EDITOR_COMPLETED"] = "image_editor--editor--completed";
    events["IMAGE_EDITOR_HISTORY_SET"] = "image_editor--editor--history--set";
})(events || (events = {}));
export default events;
